module.exports = __webpack_public_path__ + "static/media/likes-icon.2b236b76.svg";